/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@material-ui/core';
import {
  AttachFile as AttachFileIcon,
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  Description as DescriptionIcon,
  GetApp as GetAppIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Refresh as RefreshIcon,
  LocalShipping as ShippingIcon,
  Warning as WarningIcon,
} from '@material-ui/icons';

import { Skeleton } from '@mui/material';
import { FormatDate, FormatMoney } from 'components';
import {
  CustomerCard,
  EmptyState,
  FinancialSummaryCard,
  PageHeader,
  ProgressBar,
  StatusChip,
  calculateFinancialTotals,
  calculateOrderProgress,
} from 'components/Contigo';
import formatter from 'date-fns/format';
import { contigoService } from 'services';

import { FileUploadDialog } from '../../../../components/Contigo/FileUploadDialog';
import { CancelFulfillmentDialog } from './components/CancelFulfillmentDialog';
import { CancelInvoiceDialog } from './components/CancelInvoiceDialog';
import { CancelOrderDialog } from './components/CancelOrderDialog';
import { ConfirmQnNumberDialog } from './components/ConfirmQnNumberDialog';
import { ConfirmSamsungNumberDialog } from './components/ConfirmSamsungNumberDialog';
import { useStyles } from './styles';

export default function OrderDetails() {
  const classes = useStyles();
  const history = useHistory();
  const { orderId } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const [qnDialogOpen, setQnDialogOpen] = useState(false);
  const [qnNumber, setQnNumber] = useState('');
  const [samsungDialogOpen, setSamsungDialogOpen] = useState(false);
  const [samsungOrderNumber, setSamsungOrderNumber] = useState('');
  const [reissuingNFe, setReissuingNFe] = useState({});
  const [cancelInvoiceDialogOpen, setCancelInvoiceDialogOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [cancellingInvoice, setCancellingInvoice] = useState(false);
  const [cancelFulfillmentDialogOpen, setCancelFulfillmentDialogOpen] = useState(false);
  const [selectedFulfillment, setSelectedFulfillment] = useState(null);
  const [fileUploadDialogOpen, setFileUploadDialogOpen] = useState(false);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    loadOrder();
  }, [orderId]);

  const loadOrder = async () => {
    try {
      setLoading(true);
      const response = await contigoService.getOrderById(orderId);
      setOrder(response.data);
    } catch (error) {
      console.error('Erro ao carregar pedido:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.push('/contigo/orders');
  };

  const handleEdit = () => {
    history.push(`/contigo/orders/${orderId}/edit`);
  };

  const handleFulfill = () => {
    history.push(`/contigo/orders/${orderId}/fulfill`);
  };

  const handleConfirm = async () => {
    try {
      setProcessing(true);
      await contigoService.updateOrder(orderId, { status: 'CONFIRMED' });
      setConfirmDialogOpen(false);
      loadOrder();
      toast.success('Pedido confirmado com sucesso!');
    } catch (error) {
      console.error('Erro ao confirmar pedido:', error);
      toast.error('Erro ao confirmar pedido');
    } finally {
      setProcessing(false);
    }
  };

  const handleCancel = async () => {
    try {
      setProcessing(true);
      await contigoService.updateOrder(orderId, { status: 'CANCELED' });
      await contigoService.addComment(orderId, 'Pedido cancelado');
      setCancelDialogOpen(false);
      loadOrder();
      toast.success('Pedido cancelado com sucesso!');
    } catch (error) {
      console.error('Erro ao cancelar pedido:', error);
      toast.error('Erro ao cancelar pedido. Por favor, tente novamente.');
    } finally {
      setProcessing(false);
    }
  };

  const handleConfirmWithQN = async () => {
    if (!qnNumber || qnNumber.trim() === '') {
      return;
    }
    try {
      setProcessing(true);
      await contigoService.updateOrder(orderId, {
        qqn_number: qnNumber,
        status: 'PENDING_SAMSUNG',
      });
      await contigoService.addComment(orderId, `Pedido confirmado com Q&N: ${qnNumber}`);
      setQnDialogOpen(false);
      setQnNumber('');
      loadOrder();
      toast.success('Pedido confirmado com Q&N!');
    } catch (error) {
      console.error('Erro ao confirmar pedido:', error);
      toast.error('Erro ao confirmar pedido');
    } finally {
      setProcessing(false);
    }
  };

  const handleRegisterSamsung = async () => {
    if (!samsungOrderNumber || samsungOrderNumber.trim() === '') {
      return;
    }
    try {
      setProcessing(true);
      await contigoService.updateOrder(orderId, {
        samsung_order_number: samsungOrderNumber,
        status: 'AWAITING_DELIVERY',
      });
      await contigoService.addComment(orderId, `Pedido Samsung registrado: ${samsungOrderNumber}`);
      setSamsungDialogOpen(false);
      setSamsungOrderNumber('');
      loadOrder();
      toast.success('Pedido Samsung registrado com sucesso!');
    } catch (error) {
      console.error('Erro ao registrar pedido Samsung:', error);
      toast.error('Erro ao registrar pedido Samsung');
    } finally {
      setProcessing(false);
    }
  };

  const handleReissueNFe = async (invoiceId) => {
    try {
      setProcessing(true);
      setReissuingNFe((prev) => ({ ...prev, [invoiceId]: true }));
      const response = await contigoService.reissueInvoiceNFe(invoiceId);

      if (response.data.success) {
        toast.success('NFe emitida com sucesso!');
        loadOrder();
      } else {
        toast.error(`Erro ao emitir NFe: ${response.data.message}`);
      }
    } catch (error) {
      console.error('Erro ao reemitir NFe:', error);
      toast.error(`${error.response?.data?.message || error.message}`);
    } finally {
      setReissuingNFe((prev) => ({ ...prev, [invoiceId]: false }));
      setProcessing(false);
    }
  };

  const handleDownloadXml = (xmlUrl) => {
    try {
      window.open(xmlUrl, '_blank');
    } catch (error) {
      console.error('Erro ao abrir PDF:', error);
      toast.error('Erro ao abrir PDF da NFe');
    }
  };

  const handleOpenCancelInvoiceDialog = (invoice) => {
    setSelectedInvoice(invoice);
    setCancelInvoiceDialogOpen(true);
  };

  const handleCloseCancelInvoiceDialog = () => {
    setSelectedInvoice(null);
    setCancelInvoiceDialogOpen(false);
  };

  const handleConfirmCancelInvoice = async () => {
    if (!selectedInvoice) return;

    try {
      setProcessing(true);
      setCancellingInvoice(true);
      await contigoService.cancelInvoice(selectedInvoice.id);
      toast.success('Nota fiscal cancelada com sucesso! Faturamento revertido.');
      handleCloseCancelInvoiceDialog();
      loadOrder();
    } catch (error) {
      console.error('Erro ao cancelar nota fiscal:', error);
      toast.error(
        `Erro ao cancelar nota fiscal: ${error.response?.data?.message || error.message}`,
      );
    } finally {
      setCancellingInvoice(false);
      setProcessing(false);
    }
  };

  const handleOpenCancelFulfillmentDialog = (fulfillment, item) => {
    setSelectedFulfillment({ ...fulfillment, item });
    setCancelFulfillmentDialogOpen(true);
  };

  const handleCloseCancelFulfillmentDialog = () => {
    setSelectedFulfillment(null);
    setCancelFulfillmentDialogOpen(false);
  };

  const handleConfirmCancelFulfillment = async () => {
    if (!selectedFulfillment) return;

    try {
      setProcessing(true);
      await contigoService.returnFulfillment(selectedFulfillment.id, orderId);
      toast.success('Atendimento cancelado com sucesso! Estoque devolvido.');
      handleCloseCancelFulfillmentDialog();
      loadOrder();
    } catch (error) {
      console.error('Erro ao cancelar atendimento:', error);
      toast.error(
        `Erro ao cancelar atendimento: ${error.response?.data?.message || error.message}`,
      );
    } finally {
      setProcessing(false);
    }
  };

  const canFulfill = () => {
    if (!order) return false;
    const validStatuses = [
      'AWAITING_DELIVERY',
      'IN_FULFILLMENT',
      'PARTIALLY_FULFILLED',
      'FULFILLED',
      'PARTIALLY_INVOICED',
      'INVOICED',
    ];
    return (
      validStatuses.includes(order.status) &&
      order.items.some((item) => (item.quantity_fulfilled || 0) < item.quantity)
    );
  };

  if (loading) {
    return (
      <Box className={classes.container}>
        <Skeleton variant='text' width='40%' height={40} style={{ marginBottom: 8 }} />
        <Skeleton variant='text' width='25%' height={24} style={{ marginBottom: 24 }} />
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card>
              <CardContent>
                <Skeleton variant='text' width='50%' height={32} style={{ marginBottom: 16 }} />
                <Skeleton variant='rectangular' height={60} style={{ marginBottom: 16 }} />
                <Skeleton variant='rectangular' height={300} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Skeleton variant='text' width='60%' height={24} />
                <Skeleton
                  variant='rectangular'
                  height={150}
                  style={{ marginTop: 16, marginBottom: 16 }}
                />
                <Skeleton variant='rectangular' height={200} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }

  if (!order) {
    return (
      <Box className={classes.container}>
        <EmptyState title='Pedido não encontrado' />
      </Box>
    );
  }

  const totals = calculateFinancialTotals(order.items);
  const progress = calculateOrderProgress(order.items);

  return (
    <Box className={classes.container}>
      {/* Header */}
      <PageHeader
        onBack={handleBack}
        title={order.order_number}
        subtitle={`Criado em ${formatter(
          new Date(order?.created_at) || new Date(),
          'dd/MM/yyyy',
        )} • ${order.customer.NOME}`}
        rightContent={
          <StatusChip
            status={order.status}
            size='medium'
            style={{ fontSize: 14, padding: '20px 16px' }}
          />
        }
      />

      <Card style={{ marginBottom: 24 }}>
        <CardContent>
          <Grid container spacing={3} alignItems='center'>
            <Grid item xs={12} md={6}>
              <ProgressBar
                label='Atendimento'
                value={progress.fulfillment}
                color='#7B1FA2'
                backgroundColor='#F3E5F5'
                info={`${progress.totalFulfilled} de ${progress.totalOrdered} itens (${progress.fulfillment}%)`}
              />
              <ProgressBar
                label='Faturamento'
                value={progress.invoicing}
                color='#2E7D32'
                backgroundColor='#E8F5E9'
                info={`${progress.totalInvoiced} de ${progress.totalFulfilled} atendidos (${progress.invoicing}%)`}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                {order.status === 'PENDING' && (
                  <Button
                    variant='contained'
                    color='primary'
                    startIcon={<CheckCircleIcon />}
                    onClick={() => setQnDialogOpen(true)}
                    style={{ flex: 1, minWidth: 150 }}
                  >
                    Confirmar Pedido
                  </Button>
                )}

                {order.status === 'PENDING_SAMSUNG' && (
                  <Button
                    variant='contained'
                    startIcon={<CheckCircleIcon />}
                    onClick={() => setSamsungDialogOpen(true)}
                    style={{
                      flex: 1,
                      minWidth: 200,
                      backgroundColor: '#E65100',
                      color: 'white',
                    }}
                  >
                    Registrar Pedido Samsung
                  </Button>
                )}

                {canFulfill() && (
                  <Button
                    variant='contained'
                    startIcon={<ShippingIcon />}
                    onClick={handleFulfill}
                    style={{
                      flex: 1,
                      minWidth: 150,
                      backgroundColor: '#7B1FA2',
                      color: 'white',
                    }}
                  >
                    Atender Pedido
                  </Button>
                )}

                <Button
                  variant='outlined'
                  color='primary'
                  startIcon={<AttachFileIcon />}
                  onClick={() => setFileUploadDialogOpen(true)}
                  style={{ flex: 1, minWidth: 150 }}
                >
                  Anexos
                </Button>

                {!['CANCELED', 'COMPLETED', 'INVOICED'].includes(order.status) && (
                  <Button
                    variant='outlined'
                    color='secondary'
                    startIcon={<CancelIcon />}
                    onClick={() => setCancelDialogOpen(true)}
                    style={{ flex: 1, minWidth: 150 }}
                  >
                    Cancelar
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Observações do Pedido */}
      {order.notes && (
        <Card style={{ marginBottom: 24 }}>
          <CardContent>
            <Typography
              variant='h6'
              gutterBottom
              style={{ display: 'flex', alignItems: 'center', gap: 8 }}
            >
              <DescriptionIcon color='action' />
              Observações
            </Typography>
            <Typography variant='body2' color='textSecondary' style={{ whiteSpace: 'pre-wrap' }}>
              {order.notes}
            </Typography>
          </CardContent>
        </Card>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card className={classes.mainCard}>
            <Tabs
              value={activeTab}
              onChange={(_e, newValue) => setActiveTab(newValue)}
              indicatorColor='primary'
            >
              <Tab label='Itens' />
              <Tab
                label={`Atendimentos (${
                  order.items?.reduce((sum, item) => sum + (item.fulfillments?.length || 0), 0) || 0
                })`}
              />
              <Tab label={`Faturamentos (${order.invoices?.length || 0})`} />
              <Tab label='Histórico' />
            </Tabs>

            <Box className={classes.tabContent}>
              {activeTab === 0 && (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Produto</TableCell>
                        <TableCell align='center'>Pedido</TableCell>
                        <TableCell align='center'>Atendido</TableCell>
                        <TableCell align='center'>Faturado</TableCell>
                        <TableCell align='right'>Custo Un.</TableCell>
                        <TableCell align='right'>Venda Un.</TableCell>
                        <TableCell align='right'>Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {order.items.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>
                            <Typography variant='body2' className={classes.boldText}>
                              {item.part_number}
                            </Typography>
                            <Typography variant='caption' color='textSecondary'>
                              {item.description}
                            </Typography>
                          </TableCell>
                          <TableCell align='center'>
                            <Chip label={item.quantity} size='small' color='primary' />
                          </TableCell>
                          <TableCell align='center'>
                            <Chip
                              label={item.quantity_fulfilled}
                              size='small'
                              style={{
                                backgroundColor: '#F3E5F5',
                                color: '#7B1FA2',
                              }}
                            />
                          </TableCell>
                          <TableCell align='center'>
                            <Chip
                              label={item.quantity_invoiced}
                              size='small'
                              style={{
                                backgroundColor: '#E8F5E9',
                                color: '#2E7D32',
                              }}
                            />
                          </TableCell>
                          <TableCell align='right'>
                            <FormatMoney>{item.cost_price}</FormatMoney>
                          </TableCell>
                          <TableCell align='right'>
                            <FormatMoney>{item.sell_price}</FormatMoney>
                          </TableCell>
                          <TableCell align='right'>
                            <Typography className={classes.sellPrice}>
                              <FormatMoney>{item.quantity * item.sell_price}</FormatMoney>
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {/* Tab 1: Atendimentos */}
              {activeTab === 1 && (
                <Box>
                  {order.items.some((item) => item.fulfillments && item.fulfillments.length > 0) ? (
                    order.items.map((item) =>
                      item.fulfillments && item.fulfillments.length > 0
                        ? item.fulfillments.map((fulfillment) => (
                            <Card
                              key={fulfillment.id}
                              className={classes.fulfillmentCard}
                              style={{ marginBottom: 16 }}
                            >
                              <CardContent>
                                <Box className={classes.fulfillmentHeader}>
                                  <Box>
                                    <Typography variant='subtitle1' className={classes.boldText}>
                                      {item.part_number}
                                    </Typography>
                                    <Typography variant='caption' color='textSecondary'>
                                      {item.description}
                                    </Typography>
                                  </Box>
                                  <Typography variant='body2' color='textSecondary'>
                                    <FormatDate>{fulfillment.created_at}</FormatDate> -{' '}
                                    {fulfillment.created_by_user_name}
                                  </Typography>
                                </Box>
                                <TableContainer>
                                  <Table size='small'>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Delivery</TableCell>
                                        <TableCell>NF Entrada</TableCell>
                                        <TableCell align='center'>Quantidade</TableCell>
                                        <TableCell>Local</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow>
                                        <TableCell>
                                          <Chip
                                            label={fulfillment.delivery}
                                            size='small'
                                            color='primary'
                                          />
                                        </TableCell>
                                        <TableCell>{fulfillment.nf_entrada || '-'}</TableCell>
                                        <TableCell align='center'>
                                          <Chip
                                            label={fulfillment.quantity}
                                            size='small'
                                            style={{
                                              backgroundColor: '#F3E5F5',
                                              color: '#7B1FA2',
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell>Local: {fulfillment.location}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>

                                {item.quantity_invoiced === 0 && (
                                  <Box mt={2} display='flex' justifyContent='flex-end'>
                                    <Button
                                      variant='outlined'
                                      color='secondary'
                                      size='small'
                                      onClick={() =>
                                        handleOpenCancelFulfillmentDialog(fulfillment, item)
                                      }
                                      startIcon={<CancelIcon />}
                                    >
                                      Cancelar Atendimento
                                    </Button>
                                  </Box>
                                )}
                              </CardContent>
                            </Card>
                          ))
                        : null,
                    )
                  ) : (
                    <EmptyState title='Nenhum atendimento registrado' />
                  )}
                </Box>
              )}

              {/* Tab 2: Faturamentos */}
              {activeTab === 2 && (
                <Box>
                  {order.invoices && order.invoices.length > 0 ? (
                    order.invoices.map((invoice) => (
                      <Card
                        key={invoice.id}
                        className={classes.invoiceCard}
                        style={{ marginBottom: 16 }}
                      >
                        <CardContent>
                          <Box className={classes.invoiceHeader}>
                            <Box style={{ flex: 1 }}>
                              <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Typography variant='subtitle1' className={classes.boldText}>
                                  NF {invoice.invoice_number}
                                </Typography>
                                {invoice.status === 'CANCELLED' && (
                                  <Chip
                                    icon={<CancelIcon />}
                                    label='CANCELADA'
                                    size='small'
                                    style={{ backgroundColor: '#757575', color: 'white' }}
                                  />
                                )}
                                {invoice.status === 'ERROR' && (
                                  <Chip
                                    icon={<WarningIcon />}
                                    label='Erro na emissão'
                                    size='small'
                                    color='secondary'
                                  />
                                )}
                                {invoice.status === 'PENDING' && (
                                  <Chip
                                    icon={<HourglassEmptyIcon />}
                                    label='Aguardando autorização no TinyERP'
                                    size='small'
                                    style={{ backgroundColor: '#FF9800', color: 'white' }}
                                  />
                                )}
                                {invoice.status === 'AUTHORIZED' && (
                                  <Chip
                                    icon={<CheckCircleIcon />}
                                    label='NFe Autorizada'
                                    size='small'
                                    style={{ backgroundColor: '#4CAF50', color: 'white' }}
                                  />
                                )}
                              </Box>
                              <Typography variant='body2' color='textSecondary'>
                                Emitida em <FormatDate>{invoice.created_at}</FormatDate>
                              </Typography>
                              {invoice.nfe_key && (
                                <Typography variant='caption' color='textSecondary'>
                                  Chave NFe: {invoice.nfe_key}
                                </Typography>
                              )}
                              {invoice.status === 'ERROR' && invoice.error_message && (
                                <Box
                                  style={{
                                    marginTop: 8,
                                    padding: 8,
                                    backgroundColor: '#ffebee',
                                    borderRadius: 4,
                                  }}
                                >
                                  <Typography variant='caption' color='error'>
                                    Erro: {invoice.error_message}
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                            <Box
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-end',
                                gap: 8,
                              }}
                            >
                              <Typography variant='h6' className={classes.sellPrice}>
                                <FormatMoney>{invoice.total_value}</FormatMoney>
                              </Typography>
                              <Box style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
                                {invoice.xml_path && (
                                  <Button
                                    variant='outlined'
                                    color='primary'
                                    size='small'
                                    startIcon={<GetAppIcon />}
                                    onClick={() => handleDownloadXml(invoice.xml_path)}
                                  >
                                    Visualizar NFe
                                  </Button>
                                )}
                                {invoice.status === 'ERROR' && (
                                  <Button
                                    variant='contained'
                                    color='primary'
                                    size='small'
                                    startIcon={<RefreshIcon />}
                                    onClick={() => handleReissueNFe(invoice.id)}
                                    disabled={reissuingNFe[invoice.id]}
                                  >
                                    {reissuingNFe[invoice.id] ? 'Reemitindo...' : 'Reemitir NFe'}
                                  </Button>
                                )}
                                {invoice.status !== 'CANCELLED' && (
                                  <Button
                                    variant='outlined'
                                    color='secondary'
                                    size='small'
                                    startIcon={<CancelIcon />}
                                    onClick={() => handleOpenCancelInvoiceDialog(invoice)}
                                  >
                                    Cancelar NF
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          </Box>
                          {invoice.notes && (
                            <Typography
                              variant='body2'
                              color='textSecondary'
                              style={{ marginTop: 8 }}
                            >
                              {invoice.notes}
                            </Typography>
                          )}
                          <Divider style={{ margin: '16px 0' }} />
                          <TableContainer>
                            <Table size='small'>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Produto</TableCell>
                                  <TableCell align='center'>Quantidade</TableCell>
                                  <TableCell align='right'>Preço Un.</TableCell>
                                  <TableCell align='right'>Total</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {invoice.items.map((item) => (
                                  <TableRow key={item.id}>
                                    <TableCell>
                                      <Typography variant='body2' className={classes.boldText}>
                                        {item.part_number}
                                      </Typography>
                                      <Typography variant='caption' color='textSecondary'>
                                        {item.description}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align='center'>
                                      <Chip
                                        label={item.quantity}
                                        size='small'
                                        style={{
                                          backgroundColor: '#E8F5E9',
                                          color: '#2E7D32',
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align='right'>
                                      <FormatMoney>{item.unit_price}</FormatMoney>
                                    </TableCell>
                                    <TableCell align='right'>
                                      <Typography className={classes.sellPrice}>
                                        <FormatMoney>{item.total_price}</FormatMoney>
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <EmptyState title='Nenhuma nota fiscal emitida' />
                  )}
                </Box>
              )}

              {/* Tab 3: Histórico */}
              {activeTab === 3 && (
                <Box>
                  {order.comments && order.comments.length > 0 ? (
                    <Box className={classes.historyTimeline}>
                      {order.comments.map((comment, index) => (
                        <Box key={index} className={classes.historyItem}>
                          <Box className={classes.historyDot} />
                          <Box className={classes.historyContent}>
                            <Box className={classes.historyHeader}>
                              <Typography variant='body1' style={{ fontWeight: 500 }}>
                                {comment.comment}
                              </Typography>
                              <Typography variant='caption' color='textSecondary'>
                                <FormatDate>{comment.created_at}</FormatDate>
                              </Typography>
                            </Box>
                            <Typography variant='body2' color='textSecondary'>
                              Por {comment.user}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <EmptyState title='Nenhum comentário registrado' />
                  )}
                </Box>
              )}
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          {(order.qqn_number || order.samsung_order_number) && (
            <Card className={classes.sideCard}>
              <CardContent>
                <Typography variant='subtitle1' className={classes.sideCardTitle}>
                  Informações do Pedido
                </Typography>
                <Divider className={classes.divider} />
                {order.qqn_number && (
                  <Box className={classes.infoItem}>
                    <Typography variant='body2' color='textSecondary'>
                      Número Q&N
                    </Typography>
                    <Typography variant='body1' className={classes.boldText}>
                      {order.qqn_number}
                    </Typography>
                  </Box>
                )}
                {order.samsung_order_number && (
                  <Box className={classes.infoItem}>
                    <Typography variant='body2' color='textSecondary'>
                      Pedido Samsung
                    </Typography>
                    <Typography variant='body1' className={classes.boldText}>
                      {order.samsung_order_number}
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          )}

          <CustomerCard customer={order.customer} title='Cliente' />

          <FinancialSummaryCard
            totalCost={totals.totalCost}
            totalSell={totals.totalSell}
            profit={totals.profit}
            margin={totals.margin}
          />
        </Grid>
      </Grid>

      <ConfirmQnNumberDialog
        handleConfirmWithQN={handleConfirmWithQN}
        qnDialogOpen={qnDialogOpen}
        qnNumber={qnNumber}
        setQnDialogOpen={setQnDialogOpen}
        setQnNumber={setQnNumber}
      />

      <ConfirmSamsungNumberDialog
        handleRegisterSamsung={handleRegisterSamsung}
        samsungDialogOpen={samsungDialogOpen}
        samsungOrderNumber={samsungOrderNumber}
        setSamsungOrderNumber={setSamsungOrderNumber}
        setSamsungDialogOpen={setSamsungDialogOpen}
      />

      <CancelOrderDialog
        cancelDialogOpen={cancelDialogOpen}
        handleCancel={handleCancel}
        setCancelDialogOpen={setCancelDialogOpen}
        order={order}
      />

      <CancelInvoiceDialog
        open={cancelInvoiceDialogOpen}
        onClose={handleCloseCancelInvoiceDialog}
        onConfirm={handleConfirmCancelInvoice}
        invoiceNumber={selectedInvoice?.invoice_number}
        cancelling={cancellingInvoice}
      />

      <CancelFulfillmentDialog
        open={cancelFulfillmentDialogOpen}
        onClose={handleCloseCancelFulfillmentDialog}
        onConfirm={handleConfirmCancelFulfillment}
        fulfillment={selectedFulfillment}
      />

      <FileUploadDialog
        open={fileUploadDialogOpen}
        onClose={() => setFileUploadDialogOpen(false)}
        orderId={order.id}
      />

      <Backdrop open={processing} style={{ zIndex: 9999, color: '#fff' }}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </Box>
  );
}
